"use client"
import { useState, useEffect, useRef } from "react"
import { useParams } from "react-router-dom"
import Modal from "react-modal"
// import Image from "next/image"
import styled from "styled-components"
import {
  FaMoneyBillWave,
  FaBuilding,
  // FaPhone,
  FaWhatsapp,
  FaLock,
  // FaQrcode
} from "react-icons/fa"
import { IoIosArrowForward } from "react-icons/io"
import Form from "./Form"
import Legal from '../PropertyDetailsComponents/Legal'
import ReviewsSection from "../PropertyDetailsComponents/ReviewsSection"

const amenitiesIcons = {
  "24X7": "/amenities/24x7.png",
  "Grand Entrance Gate": "/amenities/grand-entrance-gate.png",
  "Convenience Stores": "/amenities/convenience-stores.png",
  "Rooftop Sky Lounge": "/amenities/rooftop-sky-lounge.png",
  "Sky Deck": "/amenities/sky-deck.png",
  "Reflexology Park Deck": "/amenities/reflexology-park-deck.png",
  "Cabana Seating Park Deck": "/amenities/cabana-seating-park-deck.png",
  "Mini Golf Seating Park Deck": "/amenities/mini-golf-seating-park-deck.png",
  Football: "/amenities/football_1.png",
  "Steam Room": "/amenities/steam-room.png",
  Store: "/amenities/store.png",
  Amphitheater: "/amenities/amphitheater_1.png",
  "Solar Water Heater": "/amenities/solar-water-heater.png",
  "Maintainence Service": "/amenities/maintainence-service.png",
  Sauna: "/amenities/sauna_1.png",
  "Open Air Gym": "/amenities/open-air-gym.png",
  "Co Working Space": "/amenities/co-working-space.png",
  "Conference Room": "/amenities/conference-room.png",
  "Meditation Zone": "/amenities/meditation-zone.png",
  "Paved Compound": "/amenities/paved-compound.png",
  "Pool Table": "/amenities/pool-table.png",
  Theater: "/amenities/theater_1.png",
  "Concierge Service": "/amenities/concierge-service.png",
  "Rent Management Service": "/amenities/rent-management-service.png",
  "House Keeping": "/amenities/house-keeping.png",
  "Snooker Table": "/amenities/snooker-table.png",
  "Star Gazing Telescope": "/amenities/star-gazing-telescope.png",
  "Open Space": "/amenities/open-space.png",
  "Waste Mgt": "/amenities/waste-mgt.png",
  "Fire Protection System": "/amenities/fire-protection-system.png",
  "Gated Community": "/amenities/gated-community.png",
  "Bus Shelter": "/amenities/bus-shelter.png",
  "Community Hall": "/amenities/community-hall.png",
  "Squash Court": "/amenities/squash-court.png",
  Spa: "/amenities/spa_1.png",
  Restaurant: "/amenities/restaurant_1.png",
  "Fire-Fighting Systems": "/amenities/fire-fighting-systems.png",
  "Internal Street Lights": "/amenities/internal-street-lights.png",
  "24x7 Water": "/amenities/24x7-water.png",
  "Acupressure Park": "/amenities/acupressure-park.png",
  "Accupressure Patchway": "/amenities/accupressure-patchway.png",
  "Aerobics Center": "/amenities/aerobics-center.png",
  AC: "/amenities/ac_1.png",
  "Automatic Gate": "/amenities/automatic-gate.png",
  Badminton: "/amenities/badminton_1.png",
  "Banquet Hall": "/amenities/banquet-hall.png",
  BBQ: "/amenities/bbq_1.png",
  CCTV: "/amenities/cctv_1.png",
  Cricket: "/amenities/cricket_1.png",
  Elevator: "/amenities/elevator_1.png",
  Basketball: "/amenities/basketball_1.png",
  "Car Parking": "/amenities/car-parking.png",
  Clubhouse: "/amenities/clubhouse_1.png",
  "Kids Play": "/amenities/kids-play.png",
  "Swimming Pool": "/amenities/swmimg-pool.png",
  "Air Hockey": "/amenities/air-hockey.png",
  ATM: "/amenities/atm_1.png",
  Backyard: "/amenities/backyard_1.png",
  Balcony: "/amenities/balcony_1.png",
  Bar: "/amenities/bar_1.png",
  "Beach Volleyball": "/amenities/beach-volleyball_1.png",
  Cafe: "/amenities/cafe_1.png",
  Campfire: "/amenities/campfire_1.png",
  "Car Charger": "/amenities/car-charger.png",
  "Central AC": "/amenities/central-ac.png",
  "Chat Plaza": "/amenities/chat-plaza.png",
  Creche: "/amenities/creche_1.png",
  Curtains: "/amenities/curtains_1.png",
  "Customized Furniture": "/amenities/customized-furniture.png",
  "Cycle Track": "/amenities/cycle-track.png",
  "Dance Room": "/amenities/dance-room.png",
  "Dedicated Pantries": "/amenities/dedicated-pantries.png",
  "Designer Entrance Lobby": "/amenities/designer-entrance-lobby.png",
  "Digital Zone": "/amenities/digital-zone.png",
  "Double Height Lobby": "/amenities/double-height-lobby.png",
  "Earthquake Resistant": "/amenities/earthquake-resistant.png",
  Electricity: "/amenities/electricity_1.png",
  "Energy and Water Solution": "/amenities/energy-and-water-solution.png",
  "Entertainment Deck": "/amenities/entertainment-deck.png",
  "Entertainment Zone": "/amenities/entertainment-zone.png",
  "Equipped Kitchen": "/amenities/equipped-kitchen.png",
  "External Amenities": "/amenities/external-amenities.png",
  "False Kitchen": "/amenities/false-kitchen.png",
  "Field View": "/amenities/field-view.png",
  "Fire Pit": "/amenities/fire-pit.png",
  "Fitness Center": "/amenities/fitness-center.png",
  "Flag Hosting Zone": "/amenities/flag-hosting-zone.png",
  "Flower Garden": "/amenities/flower-garden.png",
  "Food Court": "/amenities/food-court.png",
  "Football Court": "/amenities/football-court.png",
  "Forest Walk": "/amenities/forest-walk.png",
  Fountain: "/amenities/fountain_1.png",
  "Front Yard": "/amenities/front-yard.png",
  "Fully Furnished": "/amenities/fully-furnished.png",
  "Futsal Court": "/amenities/futsal-court.png",
  "Game Area": "/amenities/game-area.png",
  "Garage Attached": "/amenities/garage-attached.png",
  "Garbage Disposal": "/amenities/garbage-disposal.png",
  "Gated Complex": "/amenities/gated-complex.png",
  Gazebo: "/amenities/gazebo_1.png",
  "Generator Backup": "/amenities/generator-backup.png",
  Geyser: "/amenities/geyser_1.png",
  "Golf Course": "/amenities/golf-course.png",
  "Green Area": "/amenities/green-area.png",
  "Guest Bedroom": "/amenities/guest-bedroom.png",
  Helipad: "/amenities/helipad_1.png",
  "Helpers Quarter": "/amenities/helpers-quarter.png",
  "High End Interior": "/amenities/high-end-interior.png",
  "Hot Bath": "/amenities/hot-bath.png",
  Housekeeping: "/amenities/housekeeping_1.png",
  "Indoor Games": "/amenities/indoor-games.png",
  "Infinity Pool": "/amenities/infinity-pool.png",
  Intercom: "/amenities/intercom_1.png",
  "Internal Amenities": "/amenities/internal-amenities.png",
  "Italian Furniture": "/amenities/italian-furniture.png",
  Jacuzzi: "/amenities/jacuzzi_1.png",
  "Kids Pool": "/amenities/kids-pool.png",
  Laundry: "/amenities/laundry.png",
  "Lawn Tennis": "/amenities/lawn-tennis.png",
  "LED Lights": "/amenities/led-lights.png",
  Library: "/amenities/library_1.png",
  "Lounge Area": "/amenities/lounge-area.png",
  "Media Room": "/amenities/media-room.png",
  "Outdoor Gym": "/amenities/outdoor-gym.png",
  "Party Deck": "/amenities/party-deck.png",
  "Party Hall": "/amenities/party-hall.png",
  "Party Lawn": "/amenities/party-lawn.png",
  Pathway: "/amenities/pathway_1.png",
  Pergola: "/amenities/pergola_1.png",
  "Pet Park": "/amenities/pet-park.png",
  "Pipe Gas": "/amenities/pipe-gas.png",
  "Private Terrace": "/amenities/private-terrace.png",
  "Property Management": "/amenities/property-management.png",
  "Proximity to Beach": "/amenities/proximity-to-beach.png",
  "Rain Water Harvesting": "/amenities/rain-water-harvesting.png",
  School: "/amenities/school_1.png",
  "Seating Area": "/amenities/seating-area.png",
  "Seminar Hall": "/amenities/seminar-hall.png",
  "Senior Citizen Area": "/amenities/senior-citizen-area.png",
  "Sewage Treatment Plant": "/amenities/sewage-treatment-plant.png",
  "Shopping Plaza": "/amenities/shopping-plaza.png",
  "Sit Out Area": "/amenities/sit-out-area.png",
  "Skating Ring": "/amenities/skating-ring.png",
  "Smart Home": "/amenities/smart-home.png",
  "Smoke Detection": "/amenities/smoke-detection.png",
  "Wide Road 50x50": "/amenities/wide-road-50z50.png",
  Society: "/amenities/society.png",
  "Society Office": "/amenities/society-office.png",
  "Stilt Parking": "/amenities/stilt-parking.png",
  "Sun Deck": "/amenities/sun-deck.png",
  Supermarket: "/amenities/supermarket.png",
  "Table Tennis": "/amenities/table-tennis.png",
  Temple: "/amenities/temple.png",
  "Theme Wall": "/amenities/theme-wall.png",
  Transformer: "/amenities/transformer_1.png",
  "Tree House": "/amenities/tree-house.png",
  Utilities: "/amenities/utilities_1.png",
  "Vastu Compliance": "/amenities/vastu-compliance.png",
  Ventilation: "/amenities/ventilation_1.png",
  "Video Door": "/amenities/video-door.png",
  "VR Game": "/amenities/vr-game.png",
  "Work From Home": "/amenities/work-from-home.png",
  "Yoga Room": "/amenities/yoga-room.png",
  "Zen Garden": "/amenities/zen-garden.png",
  "Zip Line": "/amenities/zip-line.png"
}

// Initialize modal app element
if (typeof window !== "undefined") {
  Modal.setAppElement(document.body)
}

// Styled Components
const PropertyPage = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 2rem;
  max-width: 1200px;
  margin: 2rem auto;
  padding: 0 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

const MainContent = styled.div``

const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

const PropertyHeader = styled.div`
  position: relative;
  margin-bottom: 2rem;
`

const PropertyTitle = styled.h1`
  font-size: 2.25rem;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-weight: 700;
`

// const PropertyLocation = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 0.5rem;
//   color: #7f8c8d;
//   margin-bottom: 1rem;
//   font-size: 1.1rem;
// `

// const PriceBadge = styled.div`
//   position: absolute;
//   top: 0;
//   right: 0;
//   background: linear-gradient(135deg, #3498db, #2c3e50);
//   color: white;
//   padding: 0.5rem 1rem;
//   border-radius: 4px;
//   font-weight: 700;
//   font-size: 1.25rem;
//   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
// `

// const LabelBadge = styled.div`
//   display: inline-block;
//   background: #e74c3c;
//   color: white;
//   padding: 0.25rem 0.75rem;
//   border-radius: 4px;
//   font-size: 0.85rem;
//   font-weight: 600;
//   margin-top: 0.5rem;
// `

const ImageGallery = styled.div`
  margin-bottom: 2rem;
`

const MainImage = styled.img`
  width: 100%;
  height: 450px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 1rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 600px) {
    height: 300px;
  }
`

const ThumbnailContainer = styled.div`
  display: flex;
  gap: 1rem;
  overflow-x: auto;
  padding-bottom: 0.5rem;
`

const Thumbnail = styled.img`
  width: 100px;
  height: 75px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  border: 2px solid ${props => (props.$active ? "#3498db" : "transparent")};
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`

const NavigationTabs = styled.div`
  display: flex;
  border-bottom: 1px solid #eee;
  margin-bottom: 2rem;
`

const TabButton = styled.button`
  padding: 0.75rem 1.5rem;
  background: none;
  border: none;
  border-bottom: 3px solid
    ${props => (props.active === "true" ? "#3498db" : "transparent")};
  font-weight: ${props => (props.active === "true" ? "600" : "500")};
  color: ${props => (props.active === "true" ? "#2c3e50" : "#7f8c8d")};
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    color: #2c3e50;
  }
`

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  position: relative;
  padding-bottom: 0.5rem;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 60px;
    height: 3px;
    background: #3498db;
  }
`

const AttractiveDescription = styled.div`
  margin-bottom: 3rem;
`

const DescriptionPoint = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
`

const DescriptionIcon = styled.div`
  color: #3498db;
  font-size: 1.2rem;
  margin-top: 0.2rem;
`

const DescriptionText = styled.div`
  font-size: 1rem;
  color: #2c3e50;
`

const HighlightsSection = styled.div`
  margin-bottom: 3rem;
`

const HighlightCards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
`

const HighlightCard = styled.div`
  display: flex;
  gap: 1rem;
  padding: 1.5rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`

const HighlightIcon = styled.div`
  font-size: 1.5rem;
  color: #3498db;
  margin-top: 0.25rem;
`

const HighlightText = styled.div``

const HighlightLabel = styled.div`
  font-size: 0.9rem;
  color: #7f8c8d;
  margin-bottom: 0.25rem;
`

const HighlightValue = styled.div`
  font-size: 1.25rem;
  font-weight: 600;
  color: #2c3e50;
`

const HighlightSubtext = styled.div`
  font-size: 0.85rem;
  color: #7f8c8d;
  margin-top: 0.25rem;
`

// const FeatureHighlights = styled.div`
//   margin: 2rem 0;
//   background: #f8f9fa;
//   border-radius: 8px;
//   padding: 1.5rem;
// `

// const FeatureGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
//   gap: 1rem;
// `

// const FeatureItem = styled.div`
//   display: flex;
//   align-items: flex-start;
//   gap: 0.75rem;
//   padding: 0.5rem;
// `

// const FeatureIcon = styled.div`
//   color: #3498db;
//   font-size: 1.2rem;
//   margin-top: 0.2rem;
// `

// const FeatureText = styled.div`
//   font-size: 0.95rem;
//   color: #2c3e50;
// `

const ReraSection = styled.div`
  margin: 2rem 0;
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  align-items: center;
`

const ReraItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
`

const ReraLabel = styled.span`
  font-weight: 600;
  color: #2c3e50;
`

const ReraValue = styled.span`
  color: #555;
`

const QrCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`

const QrCodeImage = styled.img`
  width: 100px;
  height: 100px;
  object-fit: contain;
`

// const QrCodeIcon = styled(FaQrcode)`
//   font-size: 1.5rem;
//   color: #3498db;
// `

const FloorPlanSection = styled.div`
  margin-bottom: 3rem;
`

const FloorPlanContainer = styled.div`
  display: flex;
  gap: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

const FloorPlanImage = styled.img`
  flex: 2;
  width: 100%;
  max-height: 500px;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #eee;
  cursor: pointer;
`

const FloorPlanDetails = styled.div`
  flex: 1;
`

const PlanOption = styled.div`
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
`

const PlanType = styled.h3`
  font-size: 1.1rem;
  color: #2c3e50;
  margin-bottom: 0.5rem;
`

const PlanPrice = styled.p`
  font-weight: 600;
  color: #e74c3c;
`

const AmenitiesSection = styled.div`
  margin-bottom: 3rem;
`

const AmenitiesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
`

const AmenityItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
`

const AmenityIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
`

const LocationSection = styled.div`
  margin-bottom: 3rem;
`

const LocationDetails = styled.div`
  display: flex;
  gap: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

const LocationText = styled.div`
  flex: 1;

  ul {
    list-style: none;
    padding: 0;
    margin-top: 1rem;

    li {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 0.5rem;
      color: #555;
    }
  }
`

const MapContainer = styled.div`
  flex: 1;
  height: 300px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #eee;
`

const VideoSection = styled.div`
  margin-bottom: 3rem;
`

const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  background-color: #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
`

const PropertyVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
`

const VideoLoading = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: rgba(0, 0, 0, 0.7);
`

const VideoError = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 1rem;
  text-align: center;

  a {
    color: #3498db;
    margin-top: 0.5rem;
    text-decoration: underline;
  }
`

const LockedPreviewContainer = styled.div`
  position: relative;
  cursor: pointer;
  margin-bottom: 1rem;
`

const PreviewImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 8px;
  filter: blur(2px);
`

const LockOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border-radius: 8px;
`

const LockIcon = styled.div`
  font-size: 2rem;
  margin-bottom: 0.5rem;
`

const UnlockText = styled.div`
  font-size: 1.2rem;
  font-weight: 500;
`

const BrochureSection = styled.div`
  margin-bottom: 2rem;
`

const BrochureLink = styled.a`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  text-decoration: none;
  color: #2c3e50;
  transition: background-color 0.3s;

  &:hover {
    background-color: #e9ecef;
  }
`

const BrochureIcon = styled.div`
  font-size: 1.5rem;
`

const BrochureText = styled.div`
  font-weight: 500;
`

const BrochurePlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: #f8f9fa;
  border-radius: 8px;
  text-align: center;

  p {
    margin-top: 0.5rem;
    color: #7f8c8d;
  }
`

const EnquiryForm = styled.form`
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);
`

const FormTitle = styled.h3`
  font-size: 1.25rem;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  text-align: center;
`

const FormGroup = styled.div`
  margin-bottom: 1rem;
`

const FormInput = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.3s;

  &:focus {
    border-color: #3498db;
    outline: none;
  }
`

const FormSelect = styled.select`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.3s;

  &:focus {
    border-color: #3498db;
    outline: none;
  }
`

const SubmitButton = styled.button`
  width: 100%;
  padding: 0.75rem;
  background: linear-gradient(135deg, #3498db, #2c3e50);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.3s;
  margin-top: 0.5rem;

  &:hover {
    opacity: 0.9;
  }
`

const FormNote = styled.p`
  font-size: 0.85rem;
  color: #7f8c8d;
  text-align: center;
  margin-top: 1rem;
`

// const ContactBox = styled.div`
//   background: white;
//   padding: 1.5rem;
//   border-radius: 8px;
//   box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);
// `
const ErrorMessage = styled.p`
  color: red;
  font-size: 0.9rem;
  margin-top: 10px;
`

// const ContactTitle = styled.h3`
//   font-size: 1.25rem;
//   color: #2c3e50;
//   margin-bottom: 1.5rem;
//   text-align: center;
// `

// const ContactItem = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 1rem;
//   margin-bottom: 1rem;
//   padding: 0.75rem;
//   background: #f8f9fa;
//   border-radius: 4px;
// `

// const ContactIcon = styled.div`
//   color: #3498db;
// `

// const ContactText = styled.span`
//   color: #555;
// `

const WhatsAppButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem;
  background: #25d366;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  text-decoration: none;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.9;
  }
`

const WhatsAppIcon = styled.span`
  font-size: 1.25rem;
`

const StyledModal = styled(Modal)`
  position: fixed;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  max-width: 90%;
  max-height: 90%;
  overflow: auto;
  border-radius: 8px;
  outline: none;
`

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 1000;
`

const CloseModalButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 1001;
  color: white;
`

const FullSizeImage = styled.img`
  max-width: 100%;
  height: auto;
  max-height: 80vh;
`

export default function CustomPropertyPage({ isLoggedIn }) {

    // Get property id or slug from URL
  const { slug } = useParams();

//   const [propertyData, setPropertyData] = useState(null);
  const [loading, setLoading] = useState(true)
  const [fetchError, setFetchError] = useState(null)
  const [showForm, setShowForm] = useState(false)
  const [requestedSection, setRequestedSection] = useState(null)
  const [hasAccess, setHasAccess] = useState({
    video: false,
    floorPlan: false,
    brochure: false
  })
  const [videoError, setVideoError] = useState(false)
  const [isVideoLoading, setIsVideoLoading] = useState(true)
  const [videoKey, setVideoKey] = useState(0)
  const [selectedImage, setSelectedImage] = useState(null)
  const [mainImage, setMainImage] = useState("")
  const [activeTab, setActiveTab] = useState("overview")
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    interest: ""
  })
  const [step, setStep] = useState(1)
  const [otp, setOtp] = useState("")
  const [error, setError] = useState("")
  const [propertyData, setPropertyData] = useState({
  _id: "",
  title: "",
  location: "",
  price: "",
  possessionDate: "",
  propertyImages: [],
  propertyLabel: "",
  amenities: [],
  plans: [],
  slug: "",
  agentReraNumber: "",
  projectReraNumber: "",
  qrCodeUrl: "",
  keyFeatures: [],
  locationadvantages: [],
  floorPlan: null,
  propertyVideo: null,
  brochure: null,
  description: ""
});

useEffect(() => {
  if (!slug) return;
  const fetchProperty = async () => {
    setLoading(true);
    try {
      const response = await fetch(`https://pp-backend-1-sa8p.onrender.com/properties/${slug}`);
      if (!response.ok) throw new Error(await response.text());
      const data = await response.json();

      // Normalize amenities
      let normalizedAmenities = [];
      if (
        Array.isArray(data.amenities) &&
        data.amenities.length === 1 &&
        typeof data.amenities[0] === "string" &&
        data.amenities[0].includes(",")
      ) {
        normalizedAmenities = data.amenities[0].split(",").map(a => a.trim());
      } else if (Array.isArray(data.amenities)) {
        normalizedAmenities = data.amenities;
      }

      // Set propertyData with all fields and fallbacks
      setPropertyData({
        _id: data._id || "",
        title: data.title || "",
        location: data.location || "",
        price: data.price || "",
        possessionDate: data.possessionDate || "",
        propertyImages: data.propertyImages || [],
        propertyLabel: data.propertyLabel || "",
        amenities: normalizedAmenities,
        plans: data.plans || [],
        slug: data.slug || "",
        agentReraNumber: data.agentReraNumber || "",
        projectReraNumber: data.projectReraNumber || "",
        qrCodeUrl: data.qrCode?.url || "",
        keyFeatures: data.keyFeatures || [],
        locationadvantages: data.locationadvantages || [],
        floorPlan: data.floorPlan || null,
        propertyVideo: data.propertyVideo || null,
        brochure: data.brochure || null,
        description: data.description || ""
      });

      setFetchError(null);
    } catch (err) {
      setFetchError("Failed to fetch property details");
      setPropertyData(null);
    } finally {
      setLoading(false);
    }
  };
  fetchProperty();
}, [slug]);


// Load access permissions
  useEffect(() => {
    try {
      const saved = JSON.parse(localStorage.getItem("propertyAccess") || "{}")
      setHasAccess({
        video: saved.video || false,
        floorPlan: saved.floorPlan || false,
        brochure: saved.brochure || false
      })
    } catch (err) {
      console.error("Error parsing access flags:", err)
    }
  }, [])

  // Handle video autoplay when access is granted
  useEffect(() => {
    if (hasAccess.video && videoRef.current) {
      const timer = setTimeout(() => {
        videoRef.current
          ?.play()
          .catch(err => console.warn("Autoplay prevented:", err))
      }, 300)
      return () => clearTimeout(timer)
    }
  }, [hasAccess.video, videoKey])

    const videoRef = useRef(null)


   // Set main image when property images load
  useEffect(() => {
    if (propertyData && propertyData.propertyImages && propertyData.propertyImages.length > 0) {
      setMainImage(propertyData.propertyImages[0].url);
    }
  }, [propertyData]);

  if (loading) return <div>Loading...</div>;
    if (fetchError) return <div>{fetchError}</div>;
    if (!propertyData) return <div>No property found.</div>;

    const parseIndianFormattedPrice = value => {
    if (typeof value === "number") return value

    const lower = value.toLowerCase().trim()

    if (lower.endsWith("cr")) {
      return parseFloat(lower.replace("cr", "").trim()) * 10000000
    } else if (lower.endsWith("l")) {
      return parseFloat(lower.replace("l", "").trim()) * 100000
    } else {
      return parseFloat(lower.replace(/,/g, "")) || 0
    }
  }

  const formatIndianPrice = value => {
    const num = parseIndianFormattedPrice(value)

    if (num >= 10000000) {
      return `${(num / 10000000).toFixed(1).replace(/\.0$/, "")} Cr`
    } else if (num >= 100000) {
      return `${Math.round(num / 100000)} L`
    } else {
      return num.toLocaleString("en-IN")
    }
  }

  
  const handleChange = e => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const sendOtp = async () => {
    if (!formData.phone || !/^\+[1-9]\d{1,14}$/.test(formData.phone)) {
      setError(
        "Please enter a valid phone number with country code (e.g., +447700195656)"
      )
      return
    }

    try {
      const res = await fetch("https://pp-backend-1-sa8p.onrender.com/api/send-otp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ phone: formData.phone })
      })

      const data = await res.json()

      if (!res.ok) throw new Error(data.error || "Failed to send OTP")

      setStep(2)
      setError("")
    } catch (err) {
      setError(err.message)
      console.error("OTP Error:", err)
    }
  }

  const verifyOtpAndSubmit = async () => {
    try {
      const res = await fetch(
        "https://pp-backend-1-sa8p.onrender.com/api/verify-otp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            phone: formData.phone,
            otp: otp,
            name: formData.name,
            email: formData.email,
            pageUrl: window.location.href // ✅ you can use this
          })
        }
      )

      const data = await res.json()

      if (!res.ok) {
        setError(data.message || "OTP verification failed")
        return
      }

      alert("OTP verified and enquiry email sent!")
      setStep(1)
      setFormData({ name: "", phone: "", email: "", interest: "" })
      setOtp("")
      setError("")
    } catch (err) {
      console.error("Verification error:", err)
      setError("Something went wrong. Please try again.")
    }
  }

    
  
  const handleRequestAccess = section => {
    setRequestedSection(section)
    setShowForm(true)
  }

  const handleFormSubmit = success => {
    if (success) {
      const updatedAccess = {
        video: true,
        floorPlan: true,
        brochure: true
      }

      setHasAccess(updatedAccess)
      localStorage.setItem("propertyAccess", JSON.stringify(updatedAccess))

      if (propertyData.propertyVideo?.url) {
        setVideoKey(prev => prev + 1)
        setVideoError(false)
        setIsVideoLoading(true)
      }
    }
    setShowForm(false)
    setRequestedSection(null)
  }

  const handleVideoError = () => {
    setVideoError(true)
    setIsVideoLoading(false)
  }

  const handleVideoLoad = () => {
    setVideoError(false)
    setIsVideoLoading(false)
  }

  const openImageModal = url => {
    setSelectedImage(url)
  }

  const closeImageModal = () => {
    setSelectedImage(null)
  }

  const handleInputChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmitEnquiry = async e => {
    e.preventDefault()
    try {
      const response = await fetch("/api/enquiries", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...formData,
          propertyId: propertyData._id,
          propertyTitle: propertyData.title
        })
      })

      if (response.ok) {
        alert("Enquiry submitted successfully!")
        setFormData({
          name: "",
          email: "",
          phone: "",
          interest: ""
        })
      } else {
        throw new Error("Failed to submit enquiry")
      }
    } catch (error) {
      console.error("Error submitting enquiry:", error)
      alert("Error submitting enquiry. Please try again.")
    }
  }

  console.log("propertyData:", propertyData)
    // console.log(propertyData.amenities);
  // Format price with commas
  const formattedPrice = new Intl.NumberFormat("en-IN").format(
    parseInt(propertyData.price)
  )

  // Format possession date
  const formattedPossessionDate = propertyData.possessionDate
    ? new Date(propertyData.possessionDate).toLocaleDateString("en-US", {
        month: "long",
        year: "numeric"
      })
    : "Under Construction"

  // Use keyFeatures if provided, otherwise use first 10 amenities
  const features = propertyData.keyFeatures?.length
    ? propertyData.keyFeatures
    : propertyData.amenities.slice(0, 10)

  return (
    <PropertyPage>
      <MainContent>
        <PropertyHeader>
          <PropertyTitle>{propertyData.title}</PropertyTitle>
        </PropertyHeader>

        <ImageGallery>
          <MainImage
            src={mainImage || "https://via.placeholder.com/800x400"}
            alt="Main property image"
          />
          <ThumbnailContainer>
            {propertyData.propertyImages.map((img, index) => (
              <Thumbnail
                key={index}
                src={img.url}
                alt={`Property thumbnail ${index + 1}`}
                onClick={() => setMainImage(img.url)}
                $active={mainImage === img.url}
              />
            ))}
          </ThumbnailContainer>
        </ImageGallery>

        <NavigationTabs>
          <TabButton
            active={activeTab === "overview" ? "true" : "false"}
            onClick={() => setActiveTab("overview")}
          >
            Overview
          </TabButton>
          {propertyData.floorPlan && (
            <TabButton
              active={activeTab === "floorplans" ? "true" : "false"}
              onClick={() => setActiveTab("floorplans")}
            >
              Floor Plans
            </TabButton>
          )}
          {propertyData.amenities && propertyData.amenities.length > 0 && (
            <TabButton
              active={activeTab === "amenities" ? "true" : "false"}
              onClick={() => setActiveTab("amenities")}
            >
              Amenities
            </TabButton>
          )}
          <TabButton
            active={activeTab === "location" ? "true" : "false"}
            onClick={() => setActiveTab("location")}
          >
            Location
          </TabButton>
          <TabButton
            active={activeTab === "reviews" ? "true" : "false"}
            onClick={() => setActiveTab("reviews")}
          >
            Reviews 
          </TabButton>
        </NavigationTabs>

        {activeTab === "overview" && (
          <>
            <HighlightsSection>
              <SectionTitle>Property Highlights</SectionTitle>
              <HighlightCards>
                <HighlightCard>
                  <HighlightIcon>
                    <FaBuilding />
                  </HighlightIcon>
                  <HighlightText>
                    <HighlightLabel>Project Status</HighlightLabel>

                    <HighlightValue>
                      {propertyData?.propertyLabel &&
                      propertyData.propertyLabel.trim() !== ""
                        ? propertyData.propertyLabel.trim()
                        : "Status Unknown"}
                    </HighlightValue>

                    {propertyData?.propertyLabel?.trim() ===
                      "ready to move In" &&
                      propertyData?.possessionDate && (
                        <HighlightSubtext>
                          Possession since {propertyData.possessionDate}
                        </HighlightSubtext>
                      )}

                    {[
                      "pre launch",
                      "launch",
                      "mid construction",
                      "ready to move in",
                      "standard"
                    ].includes(propertyData?.propertyLabel?.trim()) &&
                      propertyData?.possessionDate && (
                        <HighlightSubtext>
                          Completion by {propertyData.possessionDate}
                        </HighlightSubtext>
                      )}
                  </HighlightText>
                </HighlightCard>

                <HighlightCard>
                  <HighlightIcon>
                    <FaMoneyBillWave />
                  </HighlightIcon>
                  <HighlightText>
                    <HighlightLabel>Price</HighlightLabel>
                    <HighlightSubtext>
                      {propertyData.price
                        ? formatIndianPrice(propertyData.price)
                        : "NAN"}
                    </HighlightSubtext>
                  </HighlightText>
                </HighlightCard>
              </HighlightCards>
            </HighlightsSection>
            {(propertyData.agentReraNumber ||
              propertyData.projectReraNumber ||
              propertyData.qrCodeUrl) && (
              <ReraSection>
                {propertyData.agentReraNumber && (
                  <ReraItem>
                    <ReraLabel>Agent RERA:</ReraLabel>
                    <ReraValue>{propertyData.agentReraNumber}</ReraValue>
                  </ReraItem>
                )}
                {propertyData.projectReraNumber && (
                  <ReraItem>
                    <ReraLabel>Project RERA:</ReraLabel>
                    <ReraValue>{propertyData.projectReraNumber}</ReraValue>
                  </ReraItem>
                )}
                {propertyData.qrCodeUrl && (
                  <QrCodeContainer>
                    <QrCodeImage
                      src={propertyData.qrCodeUrl}
                      alt="Property QR Code"
                    />
                    <ReraValue>Scan for details</ReraValue>
                  </QrCodeContainer>
                )}
              </ReraSection>
            )}

            {propertyData.description && (
              <AttractiveDescription>
                <SectionTitle>Property Description</SectionTitle>
                {propertyData.description
                  .split("\n")
                  .filter(point => point.trim())
                  .map((point, index) => (
                    <DescriptionPoint key={index}>
                      <DescriptionIcon>
                        <IoIosArrowForward />
                      </DescriptionIcon>
                      <DescriptionText>{point.trim()}</DescriptionText>
                    </DescriptionPoint>
                  ))}
              </AttractiveDescription>
            )}

            {propertyData.propertyVideo?.url && (
              <VideoSection>
                <SectionTitle>Virtual Tour</SectionTitle>
                {hasAccess.video ? (
                  <VideoContainer>
                    {isVideoLoading && (
                      <VideoLoading>Loading video...</VideoLoading>
                    )}
                    {videoError ? (
                      <VideoError>
                        <p>Video failed to load.</p>
                        <a
                          href={propertyData.propertyVideo.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Click to view video
                        </a>
                      </VideoError>
                    ) : (
                      <PropertyVideo
                        ref={videoRef}
                        key={`video-${videoKey}`}
                        controls
                        autoPlay
                        playsInline
                        onError={handleVideoError}
                        onLoadedData={handleVideoLoad}
                      >
                        <source
                          src={propertyData.propertyVideo.url}
                          type={
                            propertyData.propertyVideo.mimetype || "video/mp4"
                          }
                        />
                        Your browser does not support the video tag.
                      </PropertyVideo>
                    )}
                  </VideoContainer>
                ) : (
                  <LockedPreviewContainer
                    onClick={() => handleRequestAccess("video")}
                  >
                    <video
                      style={{ width: "100%", borderRadius: "8px" }}
                      muted
                      playsInline
                      preload="metadata"
                    >
                      <source
                        src={propertyData.propertyVideo.url}
                        type={
                          propertyData.propertyVideo.mimetype || "video/mp4"
                        }
                      />
                    </video>
                    <LockOverlay>
                      <LockIcon>
                        <FaLock />
                      </LockIcon>
                      <UnlockText>Click to unlock virtual tour</UnlockText>
                    </LockOverlay>
                  </LockedPreviewContainer>
                )}
              </VideoSection>
            )}
          </>
        )}

        {activeTab === "floorplans" && propertyData.floorPlan && (
          <FloorPlanSection>
            <SectionTitle>Floor Plans</SectionTitle>
            {hasAccess.floorPlan ? (
              <FloorPlanContainer>
                <FloorPlanImage
                  src={propertyData.floorPlan.url}
                  alt="Property floor plan"
                  onClick={() => openImageModal(propertyData.floorPlan.url)}
                />
                {propertyData.plans && propertyData.plans.length > 0 && (
                  <FloorPlanDetails>
                    {propertyData.plans.map((plan, index) => (
                      <PlanOption key={index}>
                        <PlanType>{plan} Apartment</PlanType>
                        <PlanPrice>₹{formattedPrice}</PlanPrice>
                      </PlanOption>
                    ))}
                  </FloorPlanDetails>
                )}
              </FloorPlanContainer>
            ) : (
              <LockedPreviewContainer
                onClick={() => handleRequestAccess("floorPlan")}
              >
                <PreviewImage
                  src={propertyData.floorPlan.url}
                  alt="Locked Floor Plan"
                />
                <LockOverlay>
                  <LockIcon>
                    <FaLock />
                  </LockIcon>
                  <UnlockText>Click to unlock</UnlockText>
                </LockOverlay>
              </LockedPreviewContainer>
            )}
          </FloorPlanSection>
        )}

        {activeTab === "amenities" && propertyData.amenities && (
          <AmenitiesSection>
            <SectionTitle>Amenities</SectionTitle>
            <AmenitiesGrid>
              {propertyData.amenities
                .filter(amenity => amenity)
                .map((amenity, index) => (
                  <AmenityItem key={index}>
                    <AmenityIcon>
                      <img
                        src={
                          amenitiesIcons[amenity] || "/amenities/default.png"
                        }
                        alt={amenity}
                        width={20}
                        height={20}
                      />
                    </AmenityIcon>
                    {amenity}
                  </AmenityItem>
                ))}
            </AmenitiesGrid>
          </AmenitiesSection>
        )}
        {activeTab === "location" && (
          <LocationSection>
            <SectionTitle>Location</SectionTitle>
            <LocationDetails>
              <LocationText>
                <p>Prime location in {propertyData.location.split(",")[0]}:</p>
                <ul>
                  {propertyData.location.split(",").map((part, index) => (
                    <li key={index}>
                      <IoIosArrowForward /> {part.trim()}
                    </li>
                  ))}
                </ul>

                {propertyData.locationadvantages?.length > 0 && (
                  <div style={{ marginTop: "1rem" }}>
                    <p>Key Location Advantages:</p>
                    <ul>
                      {propertyData.locationadvantages.map((adv, idx) => (
                        <li key={idx}>
                          <IoIosArrowForward /> {adv}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </LocationText>

              <MapContainer>
                <iframe
                  title="Property Location"
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  src={`https://maps.google.com/maps?q=${encodeURIComponent(
                    propertyData.location
                  )}&output=embed`}
                  allowFullScreen
                ></iframe>
              </MapContainer>
            </LocationDetails>
          </LocationSection>
        )}
        {activeTab === "reviews" && (
          <ReviewsSection isLoggedIn={isLoggedIn} propertyId={propertyData._id} />
        )}

        {propertyData.brochure?.url && (
          <BrochureSection>
            <SectionTitle>Project Brochure</SectionTitle>
            {hasAccess.brochure ? (
              <BrochureLink
                href={propertyData.brochure.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <BrochureIcon>📄</BrochureIcon>
                <BrochureText>
                  {propertyData.brochure.originalname || "Download Brochure"}
                </BrochureText>
              </BrochureLink>
            ) : (
              <LockedPreviewContainer
                onClick={() => handleRequestAccess("brochure")}
              >
                <BrochurePlaceholder>
                  <BrochureIcon>📄</BrochureIcon>
                  <p>Brochure Locked</p>
                </BrochurePlaceholder>
                <LockOverlay>
                  <LockIcon>
                    <FaLock />
                  </LockIcon>
                  <UnlockText>Click to unlock</UnlockText>
                </LockOverlay>
              </LockedPreviewContainer>
            )}
          </BrochureSection>
        )}
        
      </MainContent>

      <Sidebar>
        <EnquiryForm>
          <FormTitle>Request More Information</FormTitle>

          {step === 1 ? (
            <>
              <FormGroup>
                <FormInput
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
              <FormGroup>
                <FormInput
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
              <FormGroup>
                <FormInput
                  type="tel"
                  name="phone"
                  placeholder="Phone with country code (e.g., +447700195656)"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
              <FormGroup>
                <FormSelect
                  name="interest"
                  value={formData.interest}
                  onChange={handleChange}
                  required
                >
                  <option value="">I'm interested in</option>
                  {propertyData.plans?.map((plan, index) => (
                    <option key={index} value={plan}>
                      {plan}
                    </option>
                  ))}
                </FormSelect>
              </FormGroup>
              <SubmitButton type="button" onClick={sendOtp}>
                Send OTP
              </SubmitButton>
            </>
          ) : (
            <>
              <FormGroup>
                <label>Enter OTP</label>
                <FormInput
                  type="text"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={e => setOtp(e.target.value)}
                  required
                />
              </FormGroup>
              <SubmitButton type="button" onClick={verifyOtpAndSubmit}>
                Verify & Submit
              </SubmitButton>
            </>
          )}

          {error && <ErrorMessage>{error}</ErrorMessage>}
          <FormNote>Our representative will contact you shortly</FormNote>
        </EnquiryForm>

          <WhatsAppButton
            href={`https://wa.me/+919156091640?text=I'm interested in ${propertyData.title}`}
            target="_blank"
          >
            <WhatsAppIcon>
              <FaWhatsapp />
            </WhatsAppIcon>
            Chat on WhatsApp
          </WhatsAppButton>

          <Legal propertyId={propertyData._id} />

      </Sidebar>

      {/* Image Modal */}
      {selectedImage && (
        <StyledModal
          isOpen={!!selectedImage}
          onRequestClose={closeImageModal}
          contentLabel="Property Image"
          overlayElement={(props, contentElement) => (
            <ModalOverlay {...props}>{contentElement}</ModalOverlay>
          )}
        >
          <CloseModalButton onClick={closeImageModal}>&times;</CloseModalButton>
          <FullSizeImage
            src={selectedImage}
            alt="Property"
            width={1200}
            height={800}
            priority
          />
        </StyledModal>
      )}

      {/* Access Form Modal */}
      {showForm && requestedSection && (
        <Form
          section={requestedSection}
          delay={0}
          onSubmit={handleFormSubmit}
        />
      )}
    </PropertyPage>
  )
}
